export default __webpack_public_path__ + "static/media/activeGrid.281901d1.svg";